import React, { Component } from 'react';
import { connect } from 'react-redux';

import { notification } from 'antd';

import originAxios from 'axios';

import { errorText } from '../../shared/constants/errorText';

const withErrorHandler = (WrappedComponent, axios, rootContainer, newAxios) => {
  class Wrapper extends Component {
    constructor(props) {
      super(props);

      this.state = { errorMessage: null, error: false, didMount: false };
    }

    componentDidMount() {
      this.setupInterceptors(axios);

      if (newAxios) {
        this.setupInterceptors(newAxios);
      }

      this.setState({ didMount: true });
    }

    setupInterceptors = (localAxios) => {
      // protects from multiple subscription of same handlers
      if (localAxios.interceptors.request.handlers.length || localAxios.interceptors.response.handlers.length) {
        return;
      }

      this.reqInterceptor = localAxios.interceptors.request.use((req) => {
        const isRequestToAmazonS3 = req.url.includes('.s3.') && req.url.includes('.amazonaws.com');

        if (!isRequestToAmazonS3 && window.REACT_AUTH_TOKEN) {
          req.headers['x-nc-code'] = `${window.REACT_AUTH_TOKEN}`;
        }

        this.setState({ error: null });
        return req;
      });

      this.resInterceptor = localAxios.interceptors.response.use(
        (res) => res,
        async (error) => {
          // don't show cancel request error for user
          if (
            originAxios.isCancel(error) &&
            (error.message === errorText.canceledByUnmountComponent ||
              error.message === errorText.canceledByUser ||
              error.message === errorText.canceledByFetchingNewData)
          ) {
            throw error;
          }

          if (!error || !error.response) {
            const errorMessage = error.message ? error.message : 'Something went wrong';
            this.setState({ errorMessage: errorMessage, error: true });

            throw error;
          }

          switch (+error.response.status) {
            case 400:
              let responseData = error.response.data;

              const contentType = error.response.headers['content-type'];

              if (error.response.data instanceof Blob && contentType && contentType.indexOf('application/json') !== -1) {
                const blob = new Blob([error.response.data]);
                const data = await blob.text();
                responseData = JSON.parse(data);
              }

              this.setState({
                errorMessage: responseData.message ? responseData.message : 'Bad Request',
                error: true,
              });
              break;
            case 401:
              this.setState({ errorMessage: 'Not Authorized. Please log out and log back in', error: true });
              break;
            case 404:
              this.setState({ errorMessage: 'Not Found', error: true });
              break;
            case 504:
              this.setState({ errorMessage: 'Internal Server Error', error: true });
              break;
            case 500:
              this.setState({
                errorMessage: error.response.data.message ? error.response.data.message : 'Something went wrong',
                error: true,
              });
              break;
            default:
              this.setState({ errorMessage: 'Something went wrong', error: true });
              break;
          }

          throw error;
        },
      );
    };

    componentDidUpdate(prevProps, prevState) {
      if (this.state.error && prevState.error !== this.state.error) {
        this.openNotificationWithIcon();
      }
    }

    componentWillUnmount() {
      axios?.interceptors.request.eject(this.reqInterceptor);
      axios?.interceptors.response.eject(this.resInterceptor);

      newAxios?.interceptors.request.eject(this.reqInterceptor);
      newAxios?.interceptors.response.eject(this.resInterceptor);
    }

    openNotificationWithIcon = () => {
      notification.error({
        message: 'Error',
        top: 55,
        duration: 10,
        getContainer: this.props.rootContainer,
        description: this.state.errorMessage,
        onClose: this.handleClose(),
      });
    };

    handleClose = () => this.setState({ error: false, errorMessage: null });

    render() {
      return this.state.didMount ? <WrappedComponent {...this.props} /> : <React.Fragment />;
    }
  }

  return connect(null, null)(Wrapper);
};

export default withErrorHandler;
